import { Injectable, signal } from '@angular/core';

export interface ConfirmOptions {
  title?: string;
  confirmLabel?: string;
  destructive?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private _resolve: ((value: boolean) => void) | null = null;

  readonly state = signal<{
    message: string;
    title?: string;
    confirmLabel: string;
    destructive: boolean;
  } | null>(null);

  open(message: string, opts: ConfirmOptions = {}): Promise<boolean> {
    return new Promise(resolve => {
      this._resolve = resolve;
      this.state.set({
        message,
        title: opts.title,
        confirmLabel: opts.confirmLabel ?? 'Confirm',
        destructive: opts.destructive ?? false,
      });
    });
  }

  confirm(): void {
    this._resolve?.(true);
    this._resolve = null;
    this.state.set(null);
  }

  cancel(): void {
    this._resolve?.(false);
    this._resolve = null;
    this.state.set(null);
  }
}
